/**
 * Controls non-organizer hacker access to Home, Schedule, Mentor Cafe, Goose
 * Games, Getting Started, FAQ, Networking, Settings, Networking Result, and
 * Signage Hunt. Other roles are unchanged. RSVP, travel, Hacker Directory,
 * Hardware, Judging, and volunteer tools have independent access controls.
 */
export const HACKER_POST_RSVP_TOOLS_META_KEY = "hacker_post_rsvp_tools";

/** Event metadata key for the Travel Support chatbot feature flag. */
export const TRAVEL_SUPPORT_BOT_FLAG_KEY = "travel_support_bot";

/** Restore the legacy mentorship request and shift tools. */
export const LEGACY_MENTORSHIP_ENABLED = false;

/** Event metadata key for hardware loaning settings. */
export const HARDWARE_META_KEY = "hardware";

/** Release sponsor post-event reports without hiding their permanent route. */
export const SPONSOR_POST_EVENT_REPORT_RELEASED =
  process.env.REACT_APP_SPONSOR_POST_EVENT_REPORT_RELEASED === "true";
